/* Small progressive enhancements; no price, inventory or checkout overrides. */
(() => {
  if (window.adbModernReady) return;
  window.adbModernReady = true;
  const offerSelector = '[data-adb-product-offer], .adb-inline-fit__trust a[href*="/pages/contact?produkt="]';
  const searchParams = new URL(location.href).searchParams;
  const searchMode = searchParams.get('suchmodus');
  const modeControl = document.getElementById('AdbSearchMode');
  if (modeControl && (searchMode === 'thema' || (searchMode !== 'genau' && searchParams.has('q') && !/[":*]|\b(?:AND|OR|NOT)\b/.test(searchParams.get('q'))))) modeControl.value = 'thema';
  document.querySelectorAll('.adb-global-header__search input[name="q"]').forEach(input => {
    input.value = input.value.replace(/"/g, '');
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('.adb-search-form, .adb-global-header__search')) return;
    const input = form.querySelector('[name="q"]');
    const mode = form.id === 'AdbSearchForm' ? modeControl?.value : 'genau';
    const value = input?.value.trim() || '';
    // Native quoted terms avoid unrelated semantic expansions. Advanced
    // queries remain untouched; the alternate mode keeps semantic discovery.
    if (mode !== 'thema' && value && !/[":*]|\b(?:AND|OR|NOT)\b/.test(value)) {
      input.value = value.split(/\s+/).map(word => `"${word}"`).join(' ');
    }
  });
  function offerContext(link) {
    const form = document.querySelector('product-form-component form[action*="/cart/add"], .product-details form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    const variant = form?.querySelector('[name="id"]')?.value || new URL(location.href).searchParams.get('variant') || link.dataset.variantId;
    const quantityInput = form?.querySelector('[name="quantity"]') || document.querySelector('.product-details [name="quantity"]');
    const quantity = Math.max(1, Math.floor(Number(quantityInput?.value) || 1));
    const url = new URL(link.href, location.origin);
    if (/^\d+$/.test(variant || '')) url.searchParams.set('variant', variant);
    url.searchParams.set('menge', String(quantity));
    link.href = url.pathname + url.search + '#AdbContactForm';
  }
  // Verified on 2026-09-10 against all 543 active 4teachers descriptions.
  // Unrecoverable supplier references remain explicit inquiries, not guessed products.
  const sourceLinkRepairs = {
  "/demos/schulplaner_2627.pdf": "https://shop.4teachers.de/demos/schulplaner_2627.pdf",
  "/service/sammelbest_4tea_planer_2627.pdf": "https://shop.4teachers.de/service/sammelbest_4tea_planer_2627.pdf",
  "/Lehrerbedarf/Lern-und-Lehrmaterialien/Lernbereich-Mathematik/Zehnersystem-Rechensatz-farbig-141-teilig::1134.html": "/products/4teachers-1163-zehnersystem-rechensatz-farbig-141-teilig",
  "/Lehrerbedarf/Lern-und-Lehrmaterialien/Lernbereich-Mathematik/Zehnersystem-Rechensatz-farbig-steckbar-121-teilig::1129.html": "/products/4teachers-1158-zehnersystem-rechensatz-farbig-steckbar-121-teilig",
  "/Lehrerbedarf/Lern-und-Lehrmaterialien/Lernbereich-Mathematik/Grosser-Zehnersystem-Rechensatz-farbig-steckbar-184-teilig::1130.html": "/products/4teachers-1159-grosser-zehnersystem-rechensatz-farbig-steckbar-184-teilig",
  "/A5-Schulplaner-2023-24-Loseblattsammlung-6-fach-gelocht": "request",
  "/Stifte-Marker/Nachfuellminen-fuer-den-EASYergo-3-15-6er-Set::936.html": "request",
  "/A5-Schulplaner-2023-24-Loseblattsammlung-ungelocht": "request",
  "/Lehrerbedarf/Lehrerstempel-Sticker/Selbststempler-fuer-Lehrer-SET-3-DEUTSCH::1380.html": "request",
  "/Lehrerbedarf/Lehrerstempel-Sticker/Selbststempler-fuer-Lehrer-SET-3-ENGLISCH::1381.html": "/products/4teachers-1414-selbststempler-fuer-lehrer-set-3-englisch",
  "/Lehrerbedarf/Lehrerstempel-Sticker/Selbststempler-fuer-Lehrer-SET-3-FRANZOeSISCH::1382.html": "/products/4teachers-1415-selbststempler-fuer-lehrer-set-3-franzoesisch",
  "/Lehrerbedarf/Lehrerstempel-Sticker/Selbststempler-fuer-Lehrer-SET-3-SPANISCH::1383.html": "/products/4teachers-1416-selbststempler-fuer-lehrer-set-3-spanisch",
  "/Lehrerbedarf/Lehrerstempel-Sticker/Selbststempler-fuer-Lehrer-SET-1-DEUTSCH::1375.html": "request",
  "/Lehrerbedarf/Lehrerstempel-Sticker/Selbststempler-fuer-Lehrer-SET-1-ENGLISCH::1376.html": "https://shop.4teachers.de/Selbststempler-fuer-Lehrer-SET-1-ENGLISCH",
  "/advanced_search_result.php?keywords=Lernheft": "https://shop.4teachers.de/search/?qs=Lernheft",
  "/Buerobedarf/Markieren-Praesentieren/Nachfuellpatronen-fuer-Textmarker-GREEN-BOSS::1167.html": "https://shop.4teachers.de/Nachfuellpatronen-fuer-Textmarker-GREEN-BOSS",
  "/Schulplaner/A4-Schulplaner-2019-20-Loseblattsammlung-gelocht::1100.html": "request",
  "/advanced_search_result.php?keywords=Zehnersystem-Rechensatz+farbig": "https://shop.4teachers.de/search/?qs=Zehnersystem-Rechensatz%20farbig",
  "/4teachers-Specials/Fluessigkreide::681.html": "request",
  "/Stifte-Marker/Milchgriffel-3er-Set::479.html": "https://shop.4teachers.de/Milchgriffel-3er-Set",
  "/Lehrerbedarf/Lern-und-Lehrmaterialien/Lernbereich-Mathematik/Zehnersystem-Wuerfel-0-9999::1141.html": "request",
  "/Wuerfel-Lernspiele/10er-Wuerfel-mit-0-9::821.html": "/products/4teachers-846-10er-wuerfel-mit-0-9",
  "/Wuerfel-Lernspiele/10er-Wuerfel-mit-00-90::822.html": "/products/4teachers-847-10er-wuerfel-mit-00-90",
  "/Wuerfel-Lernspiele/10er-Wuerfel-mit-0-9-4er-Set::821.html": "/products/4teachers-846-4er-10er-wuerfel-mit-0-9-4er-set",
  "/Geschenkideen/15-Blankoboxen-in-7-Formen::785.html": "request",
  "/demos/schulplaner_2526.pdf": "https://shop.4teachers.de/demos/schulplaner_2526.pdf",
  "/service/sammelbest_4tea_planer_2526.pdf": "https://shop.4teachers.de/service/sammelbest_4tea_planer_2526.pdf",
  "/demos/wahrscheinlichkeitsrechnung.doc": "request"
};
  function repairSupplierLinks() {
    document.querySelectorAll('.product-details a[href], [data-template^="product"] a[href]').forEach(link => {
      if (link.dataset.adbSourceRepaired) return;
      const raw = link.getAttribute('href') || '';
      if (!/^(?:https?:\/\/shop\.4teachers\.de\/|(?:\.\/)?(?:demos|service)\/|\/products\/(?:demos|service)\/)/i.test(raw)) return;
      const source = new URL(raw.replace(/^\/products\//,''), 'https://shop.4teachers.de/');
      source.searchParams.delete('MODsid');
      const target = sourceLinkRepairs[source.pathname + source.search];
      if (!target) return;
      link.dataset.adbSourceRepaired = 'true';
      if (target === 'request') {
        const label = link.textContent.trim().slice(0,200);
        const product = location.pathname.split('/products/')[1]?.split('/')[0];
        const inquiry = new URL('/pages/contact',location.origin);
        if (product) inquiry.searchParams.set('produkt',product);
        inquiry.searchParams.set('verweis',label);
        inquiry.hash = 'AdbContactForm';
        link.href = inquiry.pathname + inquiry.search + inquiry.hash;
        link.dataset.adbProductOffer = '';
        link.textContent = label + ' (auf Anfrage)';
        link.title = 'Der bisherige Lieferantenverweis ist nicht mehr verfügbar. Wir helfen dir bei der Klärung.';
        link.removeAttribute('target');
      } else {
        link.href = target;
      }
    });
  }
  const refresh = () => {
    repairSupplierLinks();
    // The supplier CE-97 URL returns a confirmed 404 (HEAD and GET).
    // Keep the missing document explicit and actionable, never imply clearance.
    if (location.pathname.startsWith('/products/')) {
      document.querySelectorAll('a[href="https://labbox.com/wp-content/uploads/CRT/CE-97.pdf"]').forEach(link => {
        const inquiry = new URL('/pages/contact', location.origin);
        inquiry.searchParams.set('produkt', location.pathname.split('/products/')[1].split('/')[0]);
        inquiry.searchParams.set('verweis', 'CE-Dokument CE-97');
        link.href = inquiry.pathname + inquiry.search + '#AdbContactForm';
        link.textContent = 'CE-Dokument beim Lieferanten anfragen';
        link.dataset.adbProductOffer = '';
        link.removeAttribute('target');
      });
    }
    document.querySelectorAll(offerSelector).forEach(offerContext);
    document.querySelectorAll('button[name="checkout"] .button-text').forEach(el => { el.textContent = 'Zur Kasse'; });
    document.querySelectorAll('.product-details a[href], [data-template^="product"] a[href]').forEach(link => {
      const raw = link.getAttribute('href') || '';
      // Supplier's relative document links were resolving against /products/.
      if (/^(?:\.\/)?service\/sammelbest_4tea_planer_2627\.pdf$/i.test(raw) || /\/products\/service\/sammelbest_4tea_planer_2627\.pdf$/i.test(raw)) {
        link.href = 'https://shop.4teachers.de/service/sammelbest_4tea_planer_2627.pdf';
      }
    });
  };
  const filterBestlife = kind => {
    const catalog = document.querySelector('[data-adb-bestlife-catalog]');
    if (!catalog) return;
    let count = 0;
    catalog.querySelectorAll('[data-bestlife-kind]').forEach(card => {
      card.hidden = kind !== 'all' && card.dataset.bestlifeKind !== kind;
      if (!card.hidden) count++;
    });
    catalog.querySelectorAll('[data-bestlife-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bestlifeFilter === kind)));
    catalog.querySelector('[data-bestlife-count]').textContent = `${count} ${count === 1 ? 'Modell' : 'Modelle'}`;
  };
  const model = new URL(location.href).searchParams.get('modell');
  if (model && location.pathname.includes('/pages/contact')) {
    const field = document.querySelector('[name="contact[Produkt]"]');
    const text = document.querySelector('[name="contact[body]"]');
    const title = document.getElementById('AdbContactTitle');
    if (field) field.value = model.slice(0,300);
    if (text && !text.value.trim()) text.value = `Anfrage zu ${model.slice(0,300)}\n\nGewünschte Menge und weitere Fragen:`;
    if (title) title.textContent = 'Dein Wunschmodell anfragen';
  }
  document.addEventListener('click', event => {
    const filter = event.target.closest?.('[data-bestlife-filter], [data-bestlife-jump]');
    if (filter) filterBestlife(filter.dataset.bestlifeFilter || filter.dataset.bestlifeJump);
    const link = event.target.closest?.(offerSelector);
    if (link) offerContext(link);
    document.querySelectorAll('.adb-global-header__nav-group[open]').forEach(group => {
      if (!group.contains(event.target)) group.open = false;
    });
    const menu = document.querySelector('.adb-global-header__menu');
    if (menu?.open && !menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const groups = [...document.querySelectorAll('.adb-global-header__nav-group[open]')];
    groups.forEach(group => { group.open = false; });
    const menu = document.querySelector('.adb-global-header__menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); }
    else groups.at(-1)?.querySelector('summary')?.focus();
  });
  document.addEventListener('change', event => {
    if (event.target.matches?.('[name="quantity"], [name="id"]')) refresh();
  });
  document.addEventListener('input', event => {
    if (event.target.matches?.('[name="quantity"]')) refresh();
  });
  // Horizon resolves the selected variant asynchronously. Refresh the actual
  // href too, so copied links and opening a new tab keep the chosen variant.
  document.addEventListener('shopify:product:select', event => {
    if (event.target.closest?.('product-card')) return;
    Promise.resolve(event.promise).then(() => requestAnimationFrame(refresh)).catch(() => {});
  });
  document.addEventListener('quantity-selector:update', () => requestAnimationFrame(refresh));
  document.addEventListener('shopify:cart:lines-update', event => {
    Promise.resolve(event.promise).then(() => requestAnimationFrame(refresh)).catch(() => {});
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('variant:update', refresh);
  document.addEventListener('DOMContentLoaded', refresh, { once: true });
  if (document.readyState !== 'loading') refresh();
})();
